import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
import { Time32,UpdateWhite32, Excel32, JPG32,PNG32, AddFile32, VendorName32, Bank32, barely_black_bg_img, Cancel32, Email32, Location32, PhoneNumber32, submit } from "../../../../public/LoginImages/importimages";
import "../page.css";

const ProjectList = () => {
    const context = useContext(AdminContext)
    const { GetAllProjectList } = context
    const [project, setProjectList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 5;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getProjectList = async () => {
        let data = await GetAllProjectList()
        console.log("data", data);

        setProjectList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getProjectList()
    }, [])
    let projectList = []
    if (project.length > 0) {
        projectList = project
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = project.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, project]);
    return (
        <div style={{
            background: '#efecff',
            width: 'auto',
            minHeight: "92vh",
            transition: "margin-left 0.3s ease",
            overflowY: "auto",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            padding: 40,
            fontFamily: 'Inter, sans-serif'
        }}>
            <div style={{
                display: "grid",
                justifyContent: "center",
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: "20px",
                backgroundColor: "white",
                padding: "20px 25px",
                maxHeight: "90vh",
                overflow: "auto"
            }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                    padding: "0 20px",
                    width: "100%",
                }}>
                    <h5 style={{
                        fontWeight: "bold",
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <img
                            src={"/Project-Report-List-32.png"}
                            alt="Project Icon"
                            style={{ marginRight: "10px", width: 28, height: 28 }}
                        />
                        Project List
                    </h5>

                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "aliceblue",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        width: "250px",
                    }}>
                        <img
                            src={"/Search-32.png"}
                            alt="Search Icon"
                            style={{ width: 20, height: 20, marginRight: "8px" }}
                        />
                        <input
                            type="text"
                            placeholder="Search Project..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                border: "none",
                                outline: "none",
                                background: "transparent",
                                width: "100%",
                                fontSize: "14px",
                            }}
                        />
                    </div>
                </div>

                <div style={{ overflowX: "auto", width: "100%", }}>
                    <div style={{ maxHeight: "61vh", overflowY: "auto", width: "100%" }}>
                    <table style={{
                        backgroundColor: "white",
                        width: "100%",
                        minWidth: "1200px",
                        borderCollapse: "collapse"
                    }}>
                        <thead>
                            <tr style={{
                                backgroundColor: "#2ea4e7",
                                color: "white",
                                fontSize: "13px",
                                fontWeight: "600",
                                textAlign: "left",
                                whiteSpace: "nowrap"
                            }}>
                                <th style={{ padding: "10px" }}>Financial Year</th>
                                <th style={{ padding: "10px" }}>Project ID</th>
                                <th style={{ padding: "10px" }}>Project Name</th>
                                <th style={{ padding: "10px" }}>Project Details</th>
                                <th style={{ padding: "10px" }}>PIU</th>
                                <th style={{ padding: "10px" }}>Project Cost</th>
                                <th style={{ padding: "10px" }}>Est. Completion</th>
                                <th style={{ padding: "10px" }}>GR Number</th>
                                <th style={{ padding: "10px" }}>GR Date</th>
                                <th style={{ padding: "10px" }}>GR Copy</th>
                                <th style={{ padding: "10px" }}>Creation Date</th>
                            </tr>
                        </thead>

                        {currentBills?.map((proj, index) => (
                            <tbody key={index}>
                                <tr style={{
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    textAlign: "left",
                                    whiteSpace: 'break-spaces',
                                    backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white",
                                }}>
                                    <td style={{ padding: "10px" }}>{proj.FinancialYear}</td>
                                    <td style={{ padding: "10px" }}>{proj.ProjectId || proj.ProjectID}</td>
                                    <td style={{ padding: "10px" }}>{proj.ProjectName}</td>
                                    <td style={{ padding: "10px" }}>{proj.ProjectDetails}</td>
                                    <td style={{ padding: "10px" }}>{proj.PIU}</td>
                                    <td style={{ padding: "10px" }}>{proj.ProjectCost}</td>
                                    <td style={{ padding: "10px" }}><img
                                        src={"/Time-32.png"}
                                        style={{ marginRight: "5px", width: "15px", height: "15px" }}
                                    />{proj.ProjectEstCompletionDate?.split('T')[0]}</td>
                                    <td style={{ padding: "10px" }}>{proj.GRNumber}</td>
                                    <td style={{ padding: "10px", whiteSpace: 'nowrap' }}><img
                                        src={"/Time-32.png"}
                                        style={{ marginRight: "5px", width: "15px", height: "15px" }}
                                    />{proj.GRDate?.split('T')[0]}</td>
                                    <td style={{ padding: "10px" }}>
                                        {proj.GRCopy ? (() => {
                                            const ext = proj.GRCopy.split('.').pop().toLowerCase();
                                            let icon;
                                            if (ext === "xls" || ext === "xlsx") {
                                                icon = Excel32; // 🟢 Replace with your actual XLS icon import
                                            } else if (ext === "jpg" || ext === "jpeg") {
                                                icon = JPG32; // 🟢 Replace with your actual JPG icon import
                                            } else if (ext === "png") {
                                                icon = PNG32; // 🟢 Replace with your actual PNG icon import
                                            } else {
                                                icon = UpdateWhite32; // default icon (optional)
                                            }
                                            return (
                                                <a href={`${apiurl}/ProjectDocsImages/${proj.GRCopy}`} target="_blank" rel="noreferrer">
                                                    <img
          src={icon}
          alt={ext + " icon"}
          style={{ width: "20px", height: "20px" }}
        />
                                                    {proj.GRCopy}
                                                </a>

                                            );
                                        })() : (
                                            <span style={{ color: '#d9534f', fontWeight: 700 }}>No File</span>
                                        )}
                                    </td>
                                    {/* <td style={{ padding: "10px" }}>
                                      {item.UploadBillCopy ? (() => {
                                        // Extract file extension (lowercase)
                                        const ext = item.UploadBillCopy.split('.').pop().toLowerCase();
                                    
                                        // Choose icon based on file extension
                                        let icon;
                                        if (ext === "xls" || ext === "xlsx") {
                                          icon = Excel32; // 🟢 Replace with your actual XLS icon import
                                        } else if (ext === "jpg" || ext === "jpeg") {
                                          icon = JPG32; // 🟢 Replace with your actual JPG icon import
                                        } else if (ext === "png") {
                                          icon = PNG32; // 🟢 Replace with your actual PNG icon import
                                        } else {
                                          icon = UpdateWhite32; // default icon (optional)
                                        }
                                    
                                        return (
                                          <a
                                            href={`${apiurl}/BillCopyDocsImages/${item.UploadBillCopy}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                          >
                                            <img
                                              src={icon}
                                              alt={ext + " icon"}
                                              style={{ width: "20px", height: "20px" }}
                                            />
                                            <span>{item.UploadBillCopy}</span>
                                          </a>
                                        );
                                      })() : (
                                        <span style={{ color: '#d9534f', fontWeight: 700 }}>No File</span>
                                      )}
                                    </td> */}
                                    <td style={{ padding: "10px", whiteSpace: 'nowrap' }}><img
                                        src={"/Time-32.png"}
                                        style={{ marginRight: "5px", width: "15px", height: "15px" }}
                                    />{proj.Date?.split('T')[0]}</td>
                                </tr>
                            </tbody>
                        ))}
                    </table>
                </div>
                </div>

                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px",
                }}>
                    <div>
                        <p style={{ fontSize: "17px", color: "black" }}>
                            Showing {filteredBills?.length ? Math.min(indexOfFirstBill + 1, filteredBills?.length) : 0} to{" "}
                            {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries
                        </p>
                    </div>

                    <div style={{ display: "flex", border: "1px solid #cccccc", }}>
                        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                // border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &laquo;
                        </button>

                        <button onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))} disabled={currentPage === 1}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                // border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &lt;
                        </button>

                        <button style={{
                            padding: "8px 10px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            width: "2rem",
                            height: "2.5rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )",
                            color: "white",
                            // border: "1px solid #cccccc",
                        }}>
                            {currentPage}
                        </button>

                        <button onClick={() => setCurrentPage(prev => Math.min(totalPages || 1, prev + 1))} disabled={currentPage === totalPages}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                // border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &gt;
                        </button>

                        <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                // border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectList
